<app-card>
  <div i18n class="headline">Responses</div>
  <div class="responses">
    @for (card of cards(); track card) {
      <app-metric-card [data]="card" />
    }
  </div>
</app-card>
